module.exports = __webpack_public_path__ + "img/flag_spain.359530a5.svg";